import Nullstack from 'nullstack';
export default function IconZodiacSagittarius({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-zodiac-sagittarius",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "20",
    x2: "20",
    y2: "4"
  }), "   ", Nullstack.element("path", {
    d: "M13 4h7v7"
  }), "   ", Nullstack.element("line", {
    x1: "6.5",
    y1: "12.5",
    x2: "11.5",
    y2: "17.5"
  }), " ");
}